import React from 'react'
import FullScreenWrapper from 'components/fullScreenWrapper'
import { Heading, SubHeading, Icon, Container } from './styles'

const NotFound = () => (
	<FullScreenWrapper>
		<Container>
			<Icon
				src={require('assets/images/welcome_icon.svg')}
				alt="welcome icon"
			/>
			<Heading>Not Found</Heading>
			<SubHeading>The page you are trying to access was not found.</SubHeading>
		</Container>
	</FullScreenWrapper>
)

export default NotFound
